import type { IOtaMealPlanFormSchema } from "./NewItem"
import type { TOtaMealPlanPayload } from "./store"

export const emptyOtaMealPlanFormValues: IOtaMealPlanFormSchema = {
	name: "",
	description: "",
	meal_category: "CP",
}

export function otaMealPlanToFormValues(
	mealPlan?: TOtaMealPlanPayload
): IOtaMealPlanFormSchema {
	return mealPlan
		? {
				name: mealPlan.name,
				description: mealPlan.description || "",
				meal_category: mealPlan.meal_category || "none",
			}
		: emptyOtaMealPlanFormValues
}
